import React from "react";
import { useState, useEffect } from "react";
import GlobalFunctions from "../../services/GlobalFunctions";
import BotonPagos from "../GeneralUI/BotonPagos";

const TablaPrestamo = (params) => {
  const glob = new GlobalFunctions();
  const [cuotasMora, setCuotasMora] = useState(0);
  const [abonos, setAbonos] = useState([]);

  useEffect(() => {
    if (abonos.length !== params.datosAbonos.length) {
      setAbonos(params.datosAbonos);
    }
    if (params.cuotasMora !== cuotasMora) {
      setCuotasMora(params.cuotasMora);
    }
    try {
      let numero = parseFloat(cuotasMora);
      if (numero >= 1) {
        document.getElementById("casillaCuotasMora").style.background =
          "#FC5656";
      }
    } catch (err) {}
  });

  function validarVencimiento(fecha) {
    let background = "";
    if (Date.parse(fecha) < Date.parse(glob.getFecha())) {
      background = "#fc5656";
    }
    return background;
  }

  function validarSaldo() {
    //Revisar si el prestamo es amortizado, si lo es se debe calcular el costo del servicio a la fecha.
    //Si no lo es, establecer el saldo de la tabla
    let saldo = 0;
    let fechaAbonoInteres = "";
    let datos = {
      saldo: 0,
      interes: 0,
      totalPagar: 0,
    };
    if (params.datosPrest[0] != undefined) {
      saldo = params.datosPrest[0].tt_saldo;
      if (params.datosPrest[0].amortizado==1) {
        var fechaInicio = null;
        if (params.datosAbonos.length > 0) {
          params.datosAbonos.forEach((element) => {
            if (fechaAbonoInteres < element.fecha_abono_interes) {
              fechaAbonoInteres = element.fecha_abono_interes;
              datos.saldo = element.nuevo_saldo;
            }
          });
          fechaInicio = new Date(fechaAbonoInteres).getTime();
        } else {
          fechaInicio = new Date(params.datosPrest[0].fecha_prest).getTime();
          datos.saldo = params.datosPrest[0].valorprestamo;
        }
        var fechaHoy = new Date().getTime();
        var diff = fechaHoy - fechaInicio;
        let diasTransc = diff / (1000 * 60 * 60 * 24) - 1; 
        //Interes diario
        let intDiario = params.datosPrest[0].interes / 100 / 30;
        let intDiarioPesos = (datos.saldo * intDiario).toFixed(0);
        datos.interes = intDiarioPesos * diasTransc;
        datos.totalPagar = parseInt(datos.saldo) + parseInt(datos.interes);
        saldo=datos.totalPagar;
      }
    }
    return saldo;
  }

  return (
    <div className="table-responsive">
      <table className="table">
        <thead className="table-success">
          <tr>
            <th colSpan="4">Detalle cuenta</th>
          </tr>
        </thead>
        <thead>
          <tr>
            <th colSpan="4">{params.datosCliente[0].nombre}</th>
          </tr>
        </thead>
        <tbody>
          <tr className="align-middle">
            <th colSpan="2" scope="row">
              Fecha {params.titulo}
            </th>
            <td colSpan="2">{params.datosPrest[0].fecha_prest}</td>
          </tr>
          <tr className="align-middle">
            <th colSpan="2" scope="row">
              Valor {params.titulo}
            </th>
            <td colSpan="2">
              $ {glob.formatNumber(params.datosPrest[0].valorprestamo)}
            </td>
          </tr>
          <tr className="align-middle">
            <th colSpan="2" scope="row">
              Valor cuotas
            </th>
            <td colSpan="2">
              $ {glob.formatNumber(params.datosPrest[0].valor_cuotas)}
            </td>
          </tr>
          <tr className="align-middle">
            <th scope="row">N° cuotas</th>
            <td>{params.datosPrest[0].n_cuotas}</td>
            <th scope="row">Cuotas en mora</th>
            <td
              className="rounded"
              id="casillaCuotasMora"
              style={{ color: "black", background: "white" }}
            >
              {params.cuotasMora}
            </td>
          </tr>
          <tr className="align-middle">
            <th colSpan="2" scope="row">
              Fecha Límite de pago
            </th>
            <td
              className="rounded"
              style={{
                backgroundColor: validarVencimiento(
                  params.datosPrest[0].vencimiento
                ),
              }}
              colSpan="2"
            >
              {params.datosPrest[0].vencimiento}
            </td>
          </tr>
          <tr className="align-middle">
            <th colSpan="2" scope="row">
              Saldo
            </th>
            <td colSpan="2">$ {glob.formatNumber(validarSaldo())}</td>
          </tr>
        </tbody>
      </table>
      <BotonPagos
        fecha_prest={params.datosPrest[0].fecha_prest}
        datosCliente={params.datosCliente}
        saldoTotal={params.datosPrest[0].tt_saldo}
        valor_cuotas={params.datosPrest[0].valor_cuotas}
        url_redirect="https://financiera.tucasabonita.site/financiera/"
        fuente={params.fuente}
        nCredito="noaplica"
      />
      <table className="table">
        <thead className="table-success">
          <tr>
            <th colSpan="4">Detalle abonos</th>
          </tr>
          <tr className="align-middle">
            <th>Fecha</th>
            <th>Abono</th>
            <th>Altura cuota</th>
            <th>Asesor</th>
          </tr>
        </thead>
        <tbody>
          {abonos.map((item, index) => {
            return (
              <tr className="align-middle" key={index}>
                <td>{item.fecha}</td>
                <td style={{ color: item.valor_abono < 0 ? "red" : "black" }}>
                  {glob.formatNumber(item.valor_abono)}
                </td>
                <td>{item.altura_cuota}</td>
                <td>{item.asesor}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TablaPrestamo;
